import {all} from 'redux-saga/effects';
import { conversationsSaga } from './conversations/conversationsSaga';
import { userSaga } from './user/userSaga';
import { workspacesSaga } from './workspaces/workspacesSaga';
import { adminSaga } from './admin/adminSaga';
import { globalActionSaga } from './globalAction/globalActionSaga';

function* rootSaga() {
  yield all([
    conversationsSaga(),
    userSaga(),
    adminSaga(),
    workspacesSaga(),
    globalActionSaga()
  ]);
}

export default rootSaga;